import { observer } from "mobx-react-lite";

import { BaseInput } from "src/components/ExerciseAttributeBaseInput";
import { useWorkoutItemSetContext } from "src/workouts/WorkoutItemSetContext";

export const DefaultInput = observer(function DefaultInput() {
  const workoutItemSetContext = useWorkoutItemSetContext();
  const value = workoutItemSetContext.getEditableValue();

  return (
    <BaseInput
      disabled={workoutItemSetContext.isEditableInputDisabled()}
      placeholder={"-"}
      value={value}
      onChange={(e) => {
        workoutItemSetContext.updateEditableValue(e.currentTarget.value ?? "");
      }}
    />
  );
});
